import React from 'react';
import { object } from 'prop-types';

import {
  RequestInfoWrap,
  ContactName,
  RequestStatus,
  RequestSource,
} from './styles';

export const RequestInfo = ({ request: { contacts, source, status } }) => (
  <RequestInfoWrap>
    <ContactName>{contacts.join(', ')}</ContactName>

    <RequestSource color={source.color}>
      {source.title}
    </RequestSource>

    <RequestStatus color={status.color}>
      {status.title}
    </RequestStatus>
  </RequestInfoWrap>
);

RequestInfo.propTypes = {
  request: object,
};

RequestInfo.defaultProps = {
  request: {},
};



// WEBPACK FOOTER //
// ./src/modals/meeting-notes-modal/request-info.js